import { useProfile, useUser, useAppUI } from '../../stores';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import LoadingWindow from '../common/ui/LoadingWindow';


// This component is used to protect routes that require authentication
export const AuthenticatedRoute = () => {
  const { user, loading: authLoading, firebaseUser } = useUser();
  const { loading: profileLoading } = useProfile();
  const { appRefreshing } = useAppUI();
  const location = useLocation();

  // Show loading during auth or when Firebase user exists but platform user is still loading
  // This handles the race condition where Firebase auth succeeds but token exchange is still in progress
  if (authLoading || (firebaseUser && !user) || (user && (profileLoading || appRefreshing))) {
    return <LoadingWindow fullScreen={true} overlay={true} message="Loading Moddy AI..." />
  }

  // Only redirect to login if we truly have no authentication
  // (no Firebase user AND no platform user)
  if (!user && !firebaseUser) {
    // Redirect to login with return path
    const returnPath = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?return=${returnPath}`} replace />;
  }

  return <Outlet />;
};
